module.exports = __webpack_public_path__ + "static/media/USYG100082.d2543ea3.jpg";